module.exports = __webpack_public_path__ + "img/debf3fe.jpg";